import { Box, Button, CustomModalLayout, Heading } from '@wix/design-system';
import React from 'react';
import { SwitchProductModule } from '../../switch-product.module';
import { getSubscriptionsUrl } from '../../utils';
export const DowngradeSuccessModal = _ref => {
  let {
    callbacks
  } = _ref;
  const {
    t
  } = SwitchProductModule.internals.useTranslations();
  const successPageUrl = getSubscriptionsUrl({
    params: {
      referralInfo: 'AdvancedPlans_changePlan'
    }
  });
  React.useEffect(() => {
    callbacks == null || callbacks.onShow == null || callbacks.onShow();
  }, [callbacks]);
  const handleGoToSuccessPage = () => {
    callbacks == null || callbacks.onClick == null || callbacks.onClick({
      action: 'goToSuccessPage',
      data: {
        url: successPageUrl
      }
    });
    window.location.assign(successPageUrl);
  };
  return /*#__PURE__*/React.createElement(CustomModalLayout, {
    width: "504px",
    dataHook: "downgradeSuccessModal",
    onCloseButtonClick: handleGoToSuccessPage
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    padding: "48px",
    align: "center",
    verticalAlign: "middle",
    gap: "SP4",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Heading, null, t('change_plan.change_plan_modal.change_plan_success_title')), /*#__PURE__*/React.createElement(Button, {
    onClick: handleGoToSuccessPage
  }, t('Advanced.Plans_change.plan_modal_success.button'))));
};
//# sourceMappingURL=DowngradeSuccessModal.js.map